import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import moment from 'moment';
import { v4 } from 'uuid';

class homeSpaOfferStore {

    // Properties

    @observable spaOffers = [];
    @observable spaOfferId = 0;
    @observable taskId = 0;
    @observable taskName = '';

    @observable title = '';
    @observable titleEnglish = '';
    @observable titleChinese = '';
    @observable titleChineseTraditional = '';
    @observable titleThai = '';
    @observable titleJapanese = '';
    @observable titleVietnamese = '';

    @observable briefDesc = '';
    @observable briefDescEnglish = '';
    @observable briefDescChinese = '';
    @observable briefDescChineseTraditional = '';
    @observable briefDescThai = '';
    @observable briefDescJapanese = '';
    @observable briefDescVietnamese = '';

    @observable description = '';
    @observable descriptionEnglish = '';
    @observable descriptionChinese = '';
    @observable descriptionChineseTraditional = '';
    @observable descriptionThai = '';
    @observable descriptionJapanese = '';
    @observable descriptionVietnamese = '';

    @observable price = 0;
    @observable originalPrice = 0;
    @observable imageUrl = '';
    @observable images = [];
    @observable startDate = undefined;
    @observable endDate = undefined;
    @observable showBannerOnly = false;

    @observable homeSpaOfferLoading = false;

    @action init() {
        this.spaOffers = [];

        return ApiCaller.SpaOffer.GetAll().then((spaOfferResponses) => {
            if (spaOfferResponses) {
                spaOfferResponses.map((spaOfferResponse) => {
                    spaOfferResponse.startDate = moment(spaOfferResponse.startDate).format("DD MMMM YYYY");
                    spaOfferResponse.endDate = moment(spaOfferResponse.endDate).format("DD MMMM YYYY");

                    return spaOfferResponse;
                });

                this.spaOffers = spaOfferResponses;
            }
        })
    }

    @action initAvailable() {
        return ApiCaller.SpaOffer.GetAllAvailable().then((spaOfferResponses) => {
            if (spaOfferResponses) {
                spaOfferResponses.map((spaOfferResponse) => {
                    spaOfferResponse.startDate = moment(spaOfferResponse.startDate).format("DD MMMM YYYY");
                    spaOfferResponse.endDate = moment(spaOfferResponse.endDate).format("DD MMMM YYYY");

                    return spaOfferResponse;
                });

                this.spaOffers = spaOfferResponses;
            }
        });
    }

    @action initRead(spaOfferId) {
        this.imageUrl = '';
        
        return ApiCaller.SpaOffer.GetById(spaOfferId).then((spaOfferResponse) => {
            if (spaOfferResponse) {
                this.spaOfferId = spaOfferResponse.spaOfferId;
                this.taskId = spaOfferResponse.taskId;
                this.taskName = spaOfferResponse.taskName;

                this.briefDesc = spaOfferResponse.briefDesc;
                this.briefDescEnglish = spaOfferResponse.briefDescLang.english;
                this.briefDescChinese = spaOfferResponse.briefDescLang.chinese;
                this.briefDescChineseTraditional = spaOfferResponse.briefDescLang.chineseTraditional;
                this.briefDescThai = spaOfferResponse.briefDescLang.thai;
                this.briefDescJapanese = spaOfferResponse.briefDescLang.japanese;
                this.briefDescVietnamese = spaOfferResponse.briefDescLang.vietnamese;

                this.description = spaOfferResponse.description;
                this.descriptionEnglish = spaOfferResponse.descriptionLang.english;
                this.descriptionChinese = spaOfferResponse.descriptionLang.chinese;
                this.descriptionChineseTraditional = spaOfferResponse.descriptionLang.chineseTraditional;
                this.descriptionThai = spaOfferResponse.descriptionLang.thai;
                this.descriptionJapanese = spaOfferResponse.descriptionLang.japanese;
                this.descriptionVietnamese = spaOfferResponse.descriptionLang.vietnamese;

                this.title = spaOfferResponse.title;
                this.titleEnglish = spaOfferResponse.titleLang.english;
                this.titleChinese = spaOfferResponse.titleLang.chinese;
                this.titleChineseTraditional = spaOfferResponse.titleLang.chineseTraditional;
                this.titleThai = spaOfferResponse.titleLang.thai;
                this.titleJapanese = spaOfferResponse.titleLang.japanese;
                this.titleVietnamese = spaOfferResponse.titleLang.vietnamese;

                this.price = spaOfferResponse.price;
                this.originalPrice = spaOfferResponse.originalPrice;
                this.imageUrl = spaOfferResponse.imageUrl || '';
                this.images = [];
                if (spaOfferResponse.imageUrl) {
                    try {
                        let imagesJson = JSON.parse(spaOfferResponse.imageUrl);
                        imagesJson.map(imageJson => {
                            return imageJson.isLoading = false;
                        });
                        this.images = imagesJson;
                    } catch {
                        this.images.push({
                            id: v4(),
                            url: spaOfferResponse.imageUrl,
                            isLoading: false
                        });
                    }
                }

                this.startDate = moment(spaOfferResponse.startDate).format("DD MMMM YYYY");
                this.endDate = moment(spaOfferResponse.endDate).format("DD MMMM YYYY");

                this.showBannerOnly = spaOfferResponse.showBannerOnly;
            }
        })
    }

    @action setHomeSpaOfferLoading(value) {
        this.homeSpaOfferLoading = value;
    }

    @action resetData() {
        this.images = [];
        this.imageUrl = '';
        this.title = '';
        this.titleEnglish = '';
        this.titleChinese = '';
        this.titleChineseTraditional = '';
        this.titleThai = '';
        this.titleJapanese = '';
        this.titleVietnamese = '';

        this.description = '';
        this.descriptionEnglish = '';
        this.descriptionChinese = '';
        this.descriptionChineseTraditional = '';
        this.descriptionThai = '';
        this.descriptionJapanese = '';
        this.descriptionVietnamese = '';
    }
}

export default new homeSpaOfferStore()